import { Modal, ModalBody, ModalContent, ModalFooter } from '@nextui-org/react';

import type { FeedbackGoal } from "@/types/simulations";

import { Button } from "@/components/Button";
import OctopusCup from '/images/octopus_cup.svg';

interface FeedBackGoalsModalProps {
  onClose: () => void;
  goals: FeedbackGoal[]
}

const FeedBackGoalsModal = ({ onClose, goals }: FeedBackGoalsModalProps) => {
  const achievedGoals = goals.filter(goal => goal.achieved);

  return (
    <Modal
      isOpen
      size="lg"
      backdrop="blur"
      onOpenChange={onClose}
      hideCloseButton={true}
    >
      <ModalContent className="py-4 px-8">
        <ModalBody className="relative flex flex-col gap-8 px-0 pb-4 border-b border-borderColor/60">
          <img src={OctopusCup} alt="Octopus Cup" className="absolute top-0 right-0 max-w-[50px] md:max-w-[100px]" />
          <h1 className="text-xl font-semibold">Goals achieved in this session</h1>

          <div className="flex flex-col gap-0.5 w-full md:w-[330px]">
            {achievedGoals?.map((goal, index) => (
              <div key={`${goal}-${index}`} className="flex items-center gap-3">
                <div className="w-3 h-3 border-2 border-[#FFAA4E] rounded-full" />
                <p className="flex-1 font-semibold text-[#4D4D46]">{goal.name}</p>
              </div>
            ))}
          </div>
        </ModalBody>
        <ModalFooter className="px-0">
          <Button onClick={onClose} label="Close" className="w-full" />
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default FeedBackGoalsModal;
